import { reportVideoApi } from 'common/api';
import { errorHandleAction } from 'components/error-handle/actions';
import { put } from 'redux-saga/effects';
import { hideDialogAction } from 'components/redux-dialog/actions';
import { REPORT_VIDEO_DIALOG } from 'components/report-video';
import { REDUX_NOTIFICATION_TYPES, reduxNotificationAction } from 'components/redux-notification';
import i18next from 'i18next';

export function* reportVideoEffect({ payload: { path, message, videoId } }) {
  try {
    yield reportVideoApi(videoId, path, message);
    yield put(hideDialogAction(REPORT_VIDEO_DIALOG));
    yield put(reduxNotificationAction(i18next.t('video_reported'), true, 5, REDUX_NOTIFICATION_TYPES.SUCCESS));
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}
